/* eslint-disable func-names */
export function parseOrderCount(
  data: Record<string, number>
): Record<string, number> {
  const restaurant = Object.keys(data)
    .filter(function (key) {
      return key.startsWith("restaurant_") && key !== "restaurant_reservation_orders";
    })
    .reduce(function (r, key) {
      return r + data[key];
    }, 0);
  const pendingOrders = Object.keys(data)
    .filter(function (key) {
      return key === "distribution_cancel_orders" || key === "pending_orders";
    })
    .reduce(function (r, key) {
      return r + data[key];
    }, 0);
  const brandPendingOrders = Object.keys(data)
    .filter(function (key) {
      return (
        key === "brand_pending_orders" ||
        key === "brand_distribution_cancel_orders"
      );
    })
    .reduce(function (r, key) {
      return r + data[key];
    }, 0);
  const count = {
    ...data,
    // 临时方案，将日历房客房订单中待确认与分销取消订单数据前端手工合并
    restaurant_orders: restaurant,
    __room_orders: pendingOrders,
    __brand_room_orders: brandPendingOrders,
  };
  return count;
}
